export const HEADER = {
    MOBILE_HEIGHT: 56,
    MAIN_DESKTOP_HEIGHT: 88,
    DASHBOARD_DESKTOP_HEIGHT: 70,
    LOGO_DESKTOP_HEIGHT: 32,
    LOGO_MOBILE_HEIGHT: 26
};
export const APPBAR_ICON_SIDE = 22;
export const NAVBAR = {
    DEFAULT_DASHBOARD_WIDTH: 280,
    DASHBOARD_COLLAPSE_WIDTH: 80,
    DASHBOARD_ITEM_ROOT_HEIGHT: 48,
    DASHBOARD_ITEM_SUB_HEIGHT: 40
};
